/* eslint-disable */
/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

'use strict';

function _typeof(obj) {
  '@babel/helpers - typeof';
  if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj &&
        typeof Symbol === 'function' &&
        obj.constructor === Symbol &&
        obj !== Symbol.prototype
        ? 'symbol'
        : typeof obj;
    };
  }
  return _typeof(obj);
}

import * as _core from '@emotion/react';

import React from 'react';

import * as _propTypes from 'prop-types';

import * as _reactMergeRefs from 'react-merge-refs';

import * as _reactTransitionGroup from 'react-transition-group';

import * as _styles from './styles';

import * as _segmented_control_context from '../segmented_control/segmented_control_context';

import * as _utils from '../segmented_control/utils';

import * as _is_veneer_icon from '../utils/is_veneer_icon';

var _excluded = ['componentRef', 'icon', 'id', 'index', 'label'];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== 'function') return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(
    nodeInterop
  ) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (
    obj === null ||
    (_typeof(obj) !== 'object' && typeof obj !== 'function')
  ) {
    return { default: obj };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor =
    Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== 'default' && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor
        ? Object.getOwnPropertyDescriptor(obj, key)
        : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}

function _extends() {
  _extends =
    Object.assign ||
    function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return (
    _arrayWithHoles(arr) ||
    _iterableToArrayLimit(arr, i) ||
    _unsupportedIterableToArray(arr, i) ||
    _nonIterableRest()
  );
}

function _nonIterableRest() {
  throw new TypeError(
    'Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.'
  );
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === 'string') return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === 'Object' && o.constructor) n = o.constructor.name;
  if (n === 'Map' || n === 'Set') return Array.from(o);
  if (n === 'Arguments' || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i =
    arr == null
      ? null
      : (typeof Symbol !== 'undefined' && arr[Symbol.iterator]) ||
        arr['@@iterator'];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i['return'] != null) _i['return']();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

var SegmentedControlItem = /*#__PURE__*/ React.forwardRef(
  function (props, ref) {
    var componentRef = props.componentRef,
      icon = props.icon,
      id = props.id,
      index = props.index,
      label = props.label,
      segmentedControlItemProps = _objectWithoutProperties(props, _excluded);

    var _React$useContext = React.useContext(
        _segmented_control_context.default
      ),
      _React$useContext$act = _React$useContext.activeSegment,
      activeSegment =
        _React$useContext$act === void 0 ? undefined : _React$useContext$act,
      _React$useContext$isM = _React$useContext.isMobile,
      isMobile =
        _React$useContext$isM === void 0 ? false : _React$useContext$isM,
      _React$useContext$onC = _React$useContext.onChange,
      onChange =
        _React$useContext$onC === void 0 ? undefined : _React$useContext$onC,
      _React$useContext$seg = _React$useContext.segmentRefs,
      segmentRefs =
        _React$useContext$seg === void 0 ? undefined : _React$useContext$seg,
      _React$useContext$sel = _React$useContext.selectedItem,
      selectedItem =
        _React$useContext$sel === void 0 ? undefined : _React$useContext$sel,
      _React$useContext$set = _React$useContext.setActiveSegment,
      setActiveSegment =
        _React$useContext$set === void 0 ? undefined : _React$useContext$set,
      _React$useContext$sho = _React$useContext.shouldAnimate,
      shouldAnimate =
        _React$useContext$sho === void 0 ? true : _React$useContext$sho,
      _React$useContext$the = _React$useContext.theme,
      theme = _React$useContext$the === void 0 ? {} : _React$useContext$the;

    var isActive = activeSegment === componentRef; // state for keyboard navigation

    var _React$useState = React.useState(index),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeIndex = _React$useState2[0],
      setActiveIndex = _React$useState2[1];

    var style = React.useMemo(
      function () {
        return (0, _styles.default)({
          icon: icon,
          isActive: isActive,
          isMobile: isMobile,
          theme: theme
        });
      },
      [icon, isActive, isMobile, theme]
    ); // first render animation

    React.useEffect(
      function () {
        shouldAnimate.current = true;
      },
      [selectedItem, shouldAnimate]
    );

    var handleOnChange = function handleOnChange(e) {
      setActiveSegment(componentRef);
      shouldAnimate.current = true;
      if (!isActive && onChange) onChange(e, index);
    };

    var handleOnKeyDown = function handleOnKeyDown(e) {
      e.preventDefault();

      switch (e.keyCode) {
        case _utils.ARROW_DOWN:
        case _utils.ARROW_RIGHT:
          if (activeIndex + 1 < segmentRefs.length) {
            setActiveIndex(activeIndex + 1);
            setActiveSegment(segmentRefs[activeIndex + 1]);
            if (onChange) onChange(e, activeIndex + 1);
          }

          break;

        case _utils.ARROW_UP:
        case _utils.ARROW_LEFT:
          if (activeIndex - 1 >= 0) {
            setActiveIndex(activeIndex - 1);
            setActiveSegment(segmentRefs[activeIndex - 1]);
            if (onChange) onChange(e, activeIndex - 1);
          }

          break;

        default:
          break;
      }
    };

    var renderLabel = function renderLabel() {
      if (label) {
        return label;
      }

      return /*#__PURE__*/ React.isValidElement(icon)
        ? /*#__PURE__*/ React.cloneElement(
            icon,
            _extends(
              {
                customStyle: _extends(
                  {},
                  isActive ? style.active : style.icon,
                  {
                    display: 'block'
                  }
                )
              },
              (0, _is_veneer_icon.default)(icon) && {
                filled: true
              }
            )
          )
        : null;
    };

    var handleRef = (0, _reactMergeRefs.default)([componentRef, ref]);
    return (0, _core.jsx)(
      _reactTransitionGroup.Transition,
      _extends({}, segmentedControlItemProps, {
        nodeRef: componentRef,
        in: isActive,
        timeout: 300
      }),
      function (state) {
        return (0, _core.jsx)(
          'div',
          {
            'aria-checked': isActive,
            css: /*#__PURE__*/ (0, _core.css)(
              [
                style.segment,
                state === 'entered' && style.active,
                isMobile && style.mobile
              ],
              process.env.NODE_ENV === 'production'
                ? ''
                : '/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */'
            ),
            id: id,
            onClick: handleOnChange,
            onKeyDown: handleOnKeyDown,
            ref: handleRef,
            role: 'radio',
            tabIndex: isActive ? 0 : -1
          },
          renderLabel()
        );
      }
    );
  }
);
var ElementProp = typeof Element === 'undefined' ? function () {} : Element;
SegmentedControlItem.propTypes = {
  /**
   * @internal
   */
  componentRef: _propTypes.default.oneOfType([
    _propTypes.default.func,
    _propTypes.default.shape({
      current: _propTypes.default.instanceOf(ElementProp)
    })
  ]),

  /**
   * Sets the icon that will be displayed in the component.
   * Possible values: Veneer Icons, Veneer Flags and Veneer CustomImages
   */
  icon: _propTypes.default.node,

  /**
   * Sets the identifier of the component.
   */
  id: _propTypes.default.string,

  /**
   * @internal
   */
  index: _propTypes.default.number,

  /**
   * Sets the label that will be displayed in the component
   */
  label: _propTypes.default.string
};
SegmentedControlItem.defaultProps = {
  componentRef: undefined,
  icon: undefined,
  id: undefined,
  index: undefined,
  label: undefined
};
SegmentedControlItem.displayName = 'SegmentedControlItem';
var _default = SegmentedControlItem;
export default _default;
